const report = {
  namespaced: true,
  state: () => ({
    report: {
      title: '',
      season: null,
      items: [],
      filter: null
    },
    dirty: false
  }),
  mutations: {
    SET_REPORT(state, report) {
      state.report = report
    },
    RESET(state) {
      state.report = {
        title: '',
        season: null,
        items: [],
        filter: null
      }
      state.dirty = false
    },
    SET_DIRTY(state, value) {
      state.dirty = value
    },
    UPDATE_ITEM(state, item) {
      let mod = {...state.report}
      let index = mod.items.findIndex(i => i.uuid == item.uuid)
      mod.items[index] = item
      state.report = mod
    }
  },
  actions: {

  },
  getters: {
    report: state => state.report,
    dirty: state => state.dirty
  }
}

export default report